import { getPatientRef } from "../../../helper/getPatientRef";
import { api } from "@/api";

const actions = {
  setSelectedTab({ commit }, payload) {
    commit("SET_SELECTED_TAB", payload);
  },
  setNavs({ commit }, payload) {
    commit("SET_NAVS", payload);
  },
  reconstructTab({ commit }, payload) {
    commit("RECONSTRUCT_TAB", payload);
  },
  setCanManagePatientValue({ commit }, payload) {
    commit("SET_CAN_MANAGE_PATIENT", payload);
  },
  async setPatientData({ commit }, id) {
    try {
      const { data } = await getPatientRef(id);
      commit("SET_PATIENT_DATA", data);
    } catch (error) {
      console.error(error);
    }
  },
  async fetchData({ commit }, payload) {
    commit('SET_GET_LOADING', true);

    try {
      const response = await api.form.get(payload.tab, {
        params: {
          businessKey: payload.id,
        },
      });

      if (payload.tab === "pompeTherapy") {
          // response.data.content.pompeTherapy.therapies = response.data.content.pompeTherapy.therapies.reverse();
      }

      commit('SET_RESPONSE_DATA', response.data);
      commit('SET_SEQUENCE_NUMBER', response.data.content[payload.tab].seq);
     
      if (response.data.nav.length > 0) {
        commit('SET_NAVS', response.data.nav);
        // Reconstruct nav, based on each of the status
        commit("RECONSTRUCT_TAB");
      }

      commit('SET_GET_DATA_SUCCESS', true);
      commit('SET_DISABLED_FORM', response.data.disabled);
    } catch (e) {
      throw e;
    } finally {
      commit('SET_GET_LOADING', false);
    }
  },
  async updateData({ commit, state }, payload) {
    // payload needs to be tab, and id from route params
    commit('SET_UPDATE_LOADING', true);

    try {
      const response = await api.form.put({
        payload: state.content[payload.tab],
        page: payload.tab,
        params: {
          businessKey: payload.id,
        },
      });

      commit('SET_RESPONSE_DATA', response.data);

      if (response.data.nav.length > 0) {
        commit('SET_NAVS', response.data.nav);
        // Reconstruct nav, based on each of the status
        commit("RECONSTRUCT_TAB");
      }
    } catch (e) {
      throw e;
    } finally {
      commit('SET_UPDATE_LOADING', false);
    }
  },
};

export default actions;
